import { Toaster as Sonner, type ToasterProps } from 'sonner'

import { useTheme } from '@/theme/theme-context'

/**
 * Toast styling is driven entirely by the theme tokens rather than sonner's own
 * palette, so notifications follow a mode switch along with everything else.
 * Radius and shadow come from the same scale as popovers, so a toast reads as
 * one more floating surface rather than a third-party widget.
 */
function Toaster(props: ToasterProps) {
    const { resolvedTheme } = useTheme()

    return (
        <Sonner
            theme={resolvedTheme}
            position="bottom-right"
            closeButton
            toastOptions={{ classNames: { toast: 'shadow-lg!' } }}
            style={
                {
                    '--border-radius': 'var(--radius-lg)',
                    '--normal-bg': 'var(--popover)',
                    '--normal-text': 'var(--popover-foreground)',
                    '--normal-border': 'var(--border)',
                    '--success-bg': 'var(--success-soft)',
                    '--success-text': 'var(--success-soft-foreground)',
                    '--success-border': 'var(--success)',
                    '--error-bg': 'var(--destructive-soft)',
                    '--error-text': 'var(--destructive-soft-foreground)',
                    '--error-border': 'var(--destructive)',
                    '--warning-bg': 'var(--warning-soft)',
                    '--warning-text': 'var(--warning-soft-foreground)',
                    '--warning-border': 'var(--warning)',
                    '--info-bg': 'var(--info-soft)',
                    '--info-text': 'var(--info-soft-foreground)',
                    '--info-border': 'var(--info)'
                } as React.CSSProperties
            }
            {...props}
        />
    )
}

export { Toaster }
